import React from 'react';

// Gemeinsame Umschaltleiste der drei Projekte: BESS-Plattform | Wiki | Video-Wiki.
// Die gleiche Leiste liegt in hyper-mesh-plattform (Wiki) und hypermesh-demo (Video-Wiki).
const ITEMS = [
  { key: 'bess', label: 'BESS-Plattform', href: 'https://www.speier-solar.de/bess', title: 'Investorplattform' },
  { key: 'wiki', label: 'Wiki', href: 'https://www.hyper-mesh.de', title: 'Inhalte zu hyper-mesh' },
  { key: 'video', label: 'Video-Wiki', href: 'https://www.hypermesh.cloud', title: 'Erklärvideos' }
];

const ProjectBar = ({ current = 'bess' }) => (
  <div className="relative z-40 h-[34px] border-b border-green-500/35 bg-[#0b1f17] text-[#cfe8dc]" role="navigation" aria-label="Projekte" data-testid="project-bar">
    <div className="mx-auto flex h-full max-w-7xl items-center justify-between gap-3 px-4 text-[13px] sm:px-6 lg:px-8">
      <span className="hidden whitespace-nowrap text-[11px] uppercase tracking-[0.06em] opacity-70 sm:inline">hypermesh Projekte</span>
      <nav className="flex gap-1 max-sm:mx-auto">
        {ITEMS.map((i) => (
          <a key={i.key} href={i.href} title={i.title} aria-current={i.key === current ? 'page' : undefined}
            className={`whitespace-nowrap rounded-full px-3 py-1 no-underline max-sm:px-2 ${i.key === current ? 'bg-green-500 font-bold text-[#052e1a]' : 'text-[#cfe8dc] hover:bg-white/10'}`}>
            {i.label}
          </a>
        ))}
      </nav>
    </div>
  </div>
);

export default ProjectBar;
